import React, { useState } from 'react'
import PageShell from '../../shared/components/PageShell'
import { Box, Grid, Typography } from '@mui/material'
import { BacteriumSelect } from '../../shared/components/BacteriumSelect'
import { CountrySelectLatAm } from '../../shared/components/CountrySelectLatAm'
import image from '../../assets/Rectangle9.svg'
import BasicButtom from '../../shared/components/BasicButtom'
import { apiRequest } from '../../shared/api/apiClient'


export default function Data() {
    const [bacterium, setBacterium] = useState("Select All");
    const [selectedCountry, setSelectedCountry] = useState("All countries");
    const [loading, setLoading] = useState(false);

    const fetchChartData = async (organism, country) => {
        setLoading(true);
        try {
            const token = "569d48e99cc70b43a136acd5cf710ffdf3674d806f5dc129163290c3925373c2";
            const org = organism === "Select All" ? "all" : organism;
            const ctry = (!country || country === "All countries") ? "all" : country;
            const url = `http://api-resistencia.inmegen.gob.mx/chart_dash.php?token=${token}&organism=${encodeURIComponent(org)}&country=${encodeURIComponent(ctry)}`;
            await apiRequest(url, { method: "POST" });

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            <PageShell>
                <Grid container
                    spacing={4}
                    sx={{
                        width: '100%',
                        justifyContent: "space-between",
                        // By default, alignItems is 'stretch', making grid items of equal height.
                    }}
                >
                    <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems:'start',
                            }}>
                                <Box sx={{ width: '100%', mb: '25px', textAlign: 'left' }}>
                                    <Typography variant='h4'>
                                        Data per Region
                                    </Typography>
                                </Box>

                                <Box sx={{ width: '100%', mb: '60px', textAlign: { xs: 'center', md: 'left' } }}>
                                    <Typography variant='body1'>
                                        Download all metadata associated to the database
                                    </Typography>
                                </Box>

                                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                    <BacteriumSelect
                                        options={opts}
                                        value={bacterium}
                                        onChange={setBacterium}
                                        sx={{ maxWidth: 560, mb: 2 }}
                                    />
                                </Box>

                                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>

                                    <CountrySelectLatAm
                                        value={selectedCountry}
                                        onChange={setSelectedCountry}
                                        sx={{ maxWidth: 560, mb: '40px' }}
                                    />
                                </Box>

                                <Box sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: "flex-start",
                                }}>
                                    <BasicButtom
                                        onClick={() => fetchChartData(bacterium, selectedCountry)}
                                        loading={loading}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <Box
                                sx={{
                                    width: '80%',
                                    maxWidth: '500px',
                                    minWidth: '350px',
                                    aspectRatio: '1/1',
                                    bgcolor: '#000',
                                    borderRadius: 4,
                                    backgroundImage: image ? `url(${image})` : "none",
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}

                            />
                        </Box>
                    </Grid>
                </Grid>
            </PageShell>
        </Box>
    )
}


const opts = [
    "Acinetobacter baumannii",
    "Klebsiella pneumoniae",
    "Staphylococcus aureus",
    "Select All",
];
